/*
 * @Author: lixin jiang
 * @Date: 2021-07-08 09:18:12
 * @LastEditTime: 2021-07-15 17:16:58
 * @LastEditors: lixin jiang
 * @Description:
 * @FilePath: /@aidesign/aid-base/src/utils/rectCheckboxContext.js
 * @
 */

import * as React from 'react';

const RectCheckboxGroupContext = React.createContext({ onChange: () => {} });

export const RectCheckboxGroupContextProvider = RectCheckboxGroupContext.Provider;

export default RectCheckboxGroupContext;
